import { createStore } from 'vuex'

const store = createStore({
  state() {
    return {
      summaryViewMode: 'grid'
    }
  },
  mutations: {
    setSummaryViewMode(state, mode) {
      state.summaryViewMode = mode
    }
  },
  getters: {
    summaryViewMode(state) {
      return state.summaryViewMode
    }
  }
})

export default store

